import { TitleDetailsTabSetup, TitleTab } from "./LocationConfiguration";

export const tabToRouteMap: Record<TitleTab, string> = {
  [TitleTab.Details]: "details",
  [TitleTab.AllCopies]: "copies",
  [TitleTab.Reviews]: "reviews",
  [TitleTab.Related]: "related",
  [TitleTab.MoreInfo]: "more",
};

export function getDefaultTitleTabPath(tabSetups: TitleDetailsTabSetup[], excludedTabs: TitleTab[] = []) {
  const includedTabs = tabSetups.filter(t => !excludedTabs.includes(t.label));
  const defaultTab = includedTabs.find(t => t.defaultTab);

  if (defaultTab) {
    return tabToRouteMap[defaultTab.label];
  }

  return tabToRouteMap[TitleTab.Details];
}

